import { render, staticRenderFns } from "./testresult.vue?vue&type=template&id=678bd068&scoped=true"
import script from "./testresult.vue?vue&type=script&lang=js"
export * from "./testresult.vue?vue&type=script&lang=js"
import style0 from "./testresult.vue?vue&type=style&index=0&id=678bd068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678bd068",
  null
  
)

export default component.exports